import { useEffect, useState } from 'react';
import * as S from './styles';

export type TabsProps = {
  tabs: Array<{
    title: string;
    index: string;
  }>;
  onTabChange: (index: string) => void;
  activeTab?: string;
  style?: React.CSSProperties;
};

const Tabs = ({ tabs, activeTab, onTabChange, style }: TabsProps) => {
  const [activeIndex, setActiveIndex] = useState(tabs[0].index);

  useEffect(() => {
    if (activeTab) {
      setActiveIndex(activeTab);
    }
  }, [activeTab]);

  const onTabClick = (index: string) => {
    setActiveIndex(index);
    onTabChange(index);
  };

  return (
    <S.Wrapper style={style}>
      {tabs.map((tab) => (
        <S.Tab
          key={tab.index}
          onClick={() => onTabClick(tab.index)}
          $isActive={tab.index === activeIndex}
        >
          {tab.title}
        </S.Tab>
      ))}
    </S.Wrapper>
  );
};

export default Tabs;
